import { render, staticRenderFns } from "./InputFormName.vue?vue&type=template&id=9b1e9fb6&"
import script from "./InputFormName.vue?vue&type=script&lang=ts&"
export * from "./InputFormName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports